import {RecordForm} from '../forms/RecordForm';


import {usePipelineTemplate} from '../hooks/usePipelineTemplate.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = usePipelineTemplate();

    return (
        <FormPageLayout
            title='Add Pipeline Template'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/pipeline-templates')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
